import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import {
  GeneratedGiftcard,
  GiftcardListItem,
  ManualGiftcardInput,
} from '../interfaces/giftcard.interface';

/**
 * Émission d'un bon cadeau hors Stripe (paiement encaissé en boutique).
 * La function vérifie que l'appelant a bien `role: 'admin'`.
 */
export const createManualGiftcard = async (
  input: ManualGiftcardInput
): Promise<GeneratedGiftcard> => {
  const callable = httpsCallable<ManualGiftcardInput, GeneratedGiftcard>(
    functions,
    'createManualGiftcard'
  );
  const result = await callable(input);
  return result.data;
};

export const listGiftcards = async (params: {
  search?: string;
  limit?: number;
}): Promise<GiftcardListItem[]> => {
  const callable = httpsCallable<
    { search?: string; limit?: number },
    { items: GiftcardListItem[] }
  >(functions, 'listGiftcards');
  const result = await callable(params);
  return result.data.items;
};

/** Message affichable pour une erreur remontée par une callable Firebase. */
export const giftcardErrorMessage = (error: unknown): string => {
  const message = (error as { message?: string })?.message;
  if (message && !message.toLowerCase().startsWith('internal')) return message;
  return "Une erreur est survenue. Le bon n'a pas été généré.";
};
